import { render } from "./FormattedPrice.vue?vue&type=template&id=1b6d17de"
import script from "./FormattedPrice.vue?vue&type=script&lang=js"
export * from "./FormattedPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__